/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React from "react";
import "./Home.css";

export default function Home() {
  return (
    <div className="Home">
      <div className="lander">
        <h1>LeetAuth</h1>
        <p>The leading authentication system in speed and security</p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home.js